// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"p8-z"};